/**
 * Company: SPHMedia
 * Description: [Revised footer]
 */

import BHMINGUULOGO from "@assets/footer/bh-minggu-mobile-logo.svg";
import BHLOGO from "@assets/footer/bh-mobile-logo.svg";
import { MainContainerNew } from "@components/Blocks/Container/MainContainerNew";
import { NoSSR } from "@sphtech/web2-core/components";
import { ReactElement } from "react";
import { useLocation } from "react-router";

import { FooterCopyright } from "./FooterCopyright";
import {
  FOOTER_APP_DOWNLOAD_MENU,
  FOOTER_SOCIAL_MENU,
  FOOTER_SUB_MENU,
  FOOTER_TOP_MENU,
} from "./footerMenuConstants";
import { FooterMenuList } from "./FooterMenuList";

/**
 * FooterNewV2
 * Description: [Revised footer component]
 * @param props - The props required by the component (if any)
 * @returns The rendered React element
 */
export default function FooterNewV2({
  testId = "footer",
}: {
  testId?: string;
}): ReactElement {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const isMobWebView = searchParams.get("mobwebview");

  if (isMobWebView) {
    return <></>;
  }

  return (
    <div
      data-testid={`${testId}-footerContainer`}
      className="py-5 md:pt-6 md:pb-3 lg:pt-5 px-0 bg-brand-primary border-t-4 border-yellow-100 text-text-inverse"
    >
      <MainContainerNew className="lg:max-w-screen-lg xl:max-w-screen-cxl w-full mx-auto px-5 md:px-[15px] lg:px-0">
        <div className="flex flex-col md:flex-row gap-[21px] md:gap-[65px]">
          <div className="flex gap-[21px] flex-col basis-1/5 min-w-[240px]">
            <div className="flex gap-6 items-start">
              <img src={BHLOGO} alt="footer-logo" width={144} />
              <img
                src={BHMINGUULOGO}
                alt="footer-minggu-logo"
                width={161}
                className="md:hidden"
              />
            </div>
            <FooterMenuList
              testId={testId}
              items={FOOTER_APP_DOWNLOAD_MENU}
              type="appDownload"
            />
            <div className="flex flex-col gap-[21px]">
              <FooterMenuList
                testId={testId}
                items={FOOTER_TOP_MENU}
                type="top"
              />
              <FooterMenuList
                testId={testId}
                items={FOOTER_SUB_MENU}
                type="eshop"
              />
            </div>
          </div>

          <div className="flex flex-col xl:flex-row xl:justify-between basis-4/5">
            <div className="lg:flex lg:flex-col lg:gap-xs max-w-full xl:max-w-[350px] text-xs text-neutral-100 leading-[150%]">
              <img
                src={BHMINGUULOGO}
                alt="footer-minggu-logo"
                width={161}
                className="hidden md:block"
              />
              <FooterMenuList
                testId={testId}
                items={FOOTER_SOCIAL_MENU}
                type="social"
              />
              <h4 className="font-primary px-0 my-sm font-semibold">
                Khidmat pelangganan
              </h4>
              <a
                href="callto:63883838"
                className="font-semimedium hover:underline"
              >
                6388-3838
              </a>
              <h4 className="font-primary my-sm px-0 font-semibold">
                Meja Berita
              </h4>
              <p className="text-neutral-100 font-primary mt-0 font-semimedium mb-4">
                Anda ada maklumat mengenai sesuatu berita menarik?
                <br />
                E-mel: bhnews@sph.com.sg
              </p>
            </div>
            <div className="lg:w-[390px] flex items-end xl:pb-[40px]">
              <NoSSR>
                <FooterCopyright className="block" testId={testId} />
              </NoSSR>
            </div>
          </div>
        </div>
      </MainContainerNew>
    </div>
  );
}
